const PREFIX = 'skymuse_';

const DEFAULT_PORTFOLIO = [
  { _id: '1', title: 'Brand Identity Design', category: 'Logo', client: 'TechCorp', description: 'Complete brand identity package including logo, color palette, and brand guidelines.', status: 'active', order: 0, featured: true, images: [], createdAt: new Date().toISOString() },
  { _id: '2', title: 'Social Media Campaign', category: 'social media', client: 'StartupX', description: 'Instagram and LinkedIn campaign reaching 100K+ impressions.', status: 'active', order: 1, featured: true, images: [], createdAt: new Date().toISOString() },
  { _id: '3', title: 'Corporate Website', category: 'Website', client: 'BizGroup', description: 'Responsive corporate website with CMS integration.', status: 'active', order: 2, featured: false, images: [], createdAt: new Date().toISOString() },
];

const DEFAULT_CONTACT = {
  companyName: 'SkyMuse', mobile: '+91 870 018 6979', whatsapp: '918700186979',
  email: 'Info@skymuse.in', supportEmail: 'support@skymuse.in',
  address: '13, Shivaji Marg, Moti Nagar, Block C, Najafgarh Road Industrial Area, Delhi, 110015',
  googleMapLink: '',
  businessHours: { weekday: '10:00 AM - 7:00 PM', saturday: '10:00 AM - 5:00 PM', sunday: 'Closed' },
  socialLinks: { whatsapp: 'https://wa.me/918700186979', instagram: 'https://www.instagram.com/skymuse.in', facebook: 'https://m.facebook.com/skymuse.in', youtube: 'https://m.youtube.com/@SkyMusedotin', twitter: 'https://x.com/skymusedotin', linkedin: 'https://linkedin.com/company/skymuse' },
};

const DEFAULT_SETTINGS = {
  siteLogo: '', favicon: '', seoTitle: 'SkyMuse Digital Marketing Agency | SEO, Social Media & Web Development Services',
  seoDescription: 'SkyMuse is a leading digital marketing agency offering SEO optimization, social media marketing, content marketing, web development, and digital advertising services.',
  ogImage: '', googleAnalytics: '', googleTagManager: '',
};

const DEFAULT_CONTENT = {};

const DEFAULTS = {
  portfolio: DEFAULT_PORTFOLIO,
  contact: DEFAULT_CONTACT,
  settings: DEFAULT_SETTINGS,
  content: DEFAULT_CONTENT,
  leads: [],
  media: [],
};

export const getData = (key) => {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (raw) return JSON.parse(raw);
    if (DEFAULTS[key]) {
      console.log(`[Storage] First load — seeding default "${key}" data`);
      setData(key, DEFAULTS[key]);
      return DEFAULTS[key];
    }
    return null;
  } catch {
    return null;
  }
};

export const setData = (key, data) => {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(data));
    console.log(`[Storage] Saved "${key}" — ${Array.isArray(data) ? data.length + ' items' : 'object'}`);
    return true;
  } catch {
    console.error(`[Storage] Failed to save "${key}"`);
    return false;
  }
};

export const removeData = (key) => {
  localStorage.removeItem(PREFIX + key);
  console.log(`[Storage] Removed "${key}"`);
};
